import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/jobs/constants';
import type { JobApi } from '@/modules/jobs/types';

import { jobsQueryKeys } from './queryKeys';

export const useJobQuery = (
  jobId: string,
  options?: Omit<
    UseQueryOptions<JobApi | undefined, Error>,
    'queryKey' | 'queryFn'
  >,
) => {
  return useQuery({
    queryKey: jobsQueryKeys.detail(jobId),
    queryFn: async () => {
      const { data } = await fetchClient.GET(endpoints.job, {
        params: { path: { id: jobId } },
      });

      return data;
    },
    staleTime: 0,
    gcTime: 5 * 60 * 1000,
    ...options,
  });
};

export type JobDetailApi = NonNullable<ReturnType<typeof useJobQuery>['data']>;
